import type {
  HorarioOutputType,
  MatriculaCreateInputType,
  MatriculaOutputType,
  MatriculaUpdateInputType,
} from '../../../shared/dto';
import { callApi } from './call-api';

export const matriculasApi = {
  criar: ({ alunoId, dados }: { alunoId: string; dados: MatriculaCreateInputType }) =>
    callApi<MatriculaOutputType>({
      method: 'POST',
      path: `/alunos/${alunoId}/matriculas`,
      body: dados,
    }),

  atualizar: ({ id, dados }: { id: string; dados: MatriculaUpdateInputType }) =>
    callApi<MatriculaOutputType>({
      method: 'PUT',
      path: `/matriculas/${id}`,
      body: dados,
    }),

  listarHorarios: (matriculaId: string) =>
    callApi<HorarioOutputType[]>({
      path: `/matriculas/${matriculaId}/horarios`,
    }),
};
